<template>
  <InfoList
    :columns="3"
    :column-breakpoints="{
      sm: 3,
      md: 3,
      lg: 3,
      xl: 3
    }"
  >
    <InfoListLabel> Danh xưng </InfoListLabel>
    <InfoListInput>{{ customerRecord.name }}</InfoListInput>

    <InfoListLabel> Họ </InfoListLabel>
    <InfoListInput>{{ customerRecord.last_name }}</InfoListInput>

    <InfoListLabel> Tên </InfoListLabel>
    <InfoListInput>{{ customerRecord.first_name }}</InfoListInput>

    <InfoListLabel>Giới tính</InfoListLabel>
    <InfoListInput>{{ customerRecord.sex == 1 ? 'Nam' : 'Nữ' }}</InfoListInput>

    <InfoListLabel> Địa chỉ e-mail </InfoListLabel>
    <InfoListInput>{{ customerRecord.email }}</InfoListInput>

    <InfoListLabel> Số điện thoại </InfoListLabel>
    <InfoListInput>{{ customerRecord.phone_number }}</InfoListInput>

    <InfoListLabel> Địa chỉ 1 </InfoListLabel>
    <InfoListInput>{{ customerRecord.address_1 }}</InfoListInput>

    <InfoListLabel> Địa chỉ 2 </InfoListLabel>
    <InfoListInput>{{ customerRecord.address_2 }}</InfoListInput>
  </InfoList>
</template>
<script>
import InfoList from '@/components/info-list/InfoList.vue'
import InfoListInput from '@/components/info-list/InfoListInput.vue'
import InfoListLabel from '@/components/info-list/InfoListLabel.vue'

export default {
  components: { InfoList, InfoListLabel, InfoListInput },
  props: {
    visible: {
      default: () => false
    },
    customerRecord: {
      default: () => {
        return {
          name: null,
          sex: 1,
          birth: null,
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          address_1: null,
          address_2: null
        }
      }
    }
  }
}
</script>
